import React, { useState, useEffect } from "react";
import { useContext } from "react";
import "./style.css";
import { Link, NavLink, useLocation } from "react-router-dom";
import Button from "../Button/Button";
import { useAuthContext } from "../../AuthContext";
import { SidebarContext } from "../Context/SidebarContext";
import TopBar from "./topBar";
import { ERROR_ROUTES } from "../../AuthContext";
import useAuth from "../../Auth";
import DesktopHeader from "./DesktopHeader";
import MobileHeader from "./MobileHeader";

const Header = ({ type }) => {
  const {
    logOut,
    // login,
    isAuthenticated,
    errorState,
    errorController,
    errorCode,
    errorImg,
    isMobile,
  } = useAuthContext();
  const PATHS = ["score", "games"];
  const location = useLocation();

  return (
    <>
      {!ERROR_ROUTES.includes(window.location.pathname) ? (
        <TopBar
          animationCls={
            errorState ? "section-topbar animation" : "section-topbar"
          }
          text={errorCode}
          image={errorImg.non_gaming}
          click={errorController}
        />
      ) : (
        ""
      )}
      {type === 1 && isMobile === true ? <MobileHeader /> : <DesktopHeader />}
    </>
  );
};

export default Header;
